import { render, staticRenderFns } from "./print-certificate.vue?vue&type=template&id=3ce1fb68&scoped=true"
import script from "./print-certificate.vue?vue&type=script&lang=js"
export * from "./print-certificate.vue?vue&type=script&lang=js"
import style0 from "./print-certificate.vue?vue&type=style&index=0&id=3ce1fb68&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce1fb68",
  null
  
)

export default component.exports